import script from "./ChallengeCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeCarousel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__